<template>
  <div>
    <b-row class="mb-3">
      <b-col sm>
        <div>
          <b-form-group
            class="mb-3"
            label="Search :"
            label-for="search"
            description="Searchable : Name"
          >
              <b-input-group
              >
                <b-form-input
                  id="search"
                  type="search"
                  v-model="filterText"
                  placeholder="Name ..."
                  @keyup.enter="doFilter"
                >
                </b-form-input>
                <b-input-group-append
                >
                  <b-button
                    variant="secondary" @click="resetFilter"
                    type="button"
                  >
                    Reset
                  </b-button>
                </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
      <b-col sm>
        <div>
          <b-form-group
            class="mb-3"
            label="Date :"
            label-for="daterange"
          >
            <b-input-group
            >
              <b-input-group-prepend is-text>
                <i class="fa fa-calendar"></i>
              </b-input-group-prepend>
              <range-picker id="daterange" :start="startDate" :end="endDate" @picker="doDateFilter"></range-picker>
              <b-input-group-append>
                <b-button type="button" variant="secondary" @click="resetDateFilter">Reset</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <div class="table-responsive">
      <vuetable ref="vuetable"
        @vuetable:load-error="handleLoadError"
        :api-url="apiUrl"
        :http-options="HttpOptions"
        :fields="fields"
        pagination-path=""
        :muti-sort="true"
        :sort-order="sortOrder"
        :append-params="moreParams"
        @vuetable:pagination-data="onPaginationData">
        <template slot="name-slot" slot-scope="prop">
          <tr :rowspan="prop.rowData.item_total">
            <td style="text-align: center; vertical-align: middle;">
              <span>{{ prop.rowData.name }}</span>
            </td>
          </tr>
        </template>
        <template slot="start_from-slot" slot-scope="prop">
          <tr :rowspan="prop.rowData.item_total">
            <td style="text-align: center; vertical-align: middle;">
              <span :style="[timeNow >= prop.rowData.end_to ? {'color' : 'red'} : {'color' : 'green'}]"
              >{{ prop.rowData.start_from }}</span> <br>
              <span :style="[timeNow >= prop.rowData.end_to ? {'color' : 'red'} : {'color' : 'green'}]"
              > - </span> <br>
              <span :style="[timeNow >= prop.rowData.end_to ? {'color' : 'red'} : {'color' : 'green'}]"
              >{{ prop.rowData.end_to }}</span>
            </td>
          </tr>
        </template>
        <template slot="updated_at-slot" slot-scope="prop">
          <tr :rowspan="prop.rowData.item_total">
            <td style="text-align: center; vertical-align: middle;">
              <span>{{ prop.rowData.updated_at }}</span>
            </td>
          </tr>
        </template>
        <template slot="item-slot" slot-scope="prop">
          <tr v-for="(item, index) in prop.rowData.details" :key="index">
            <td>{{ item.item }}</td>
          </tr>
        </template>
        <template slot="item_based-slot" slot-scope="prop">
          <tr v-for="(item, index) in prop.rowData.details" :key="index">
            <td>{{ item.item_based }}</td>
          </tr>
        </template>
        <template slot="type-slot" slot-scope="prop">
          <tr v-for="(item, index) in prop.rowData.details" :key="index">
            <td>{{ item.type }}</td>
          </tr>
        </template>
        <template slot="after_discount-slot" slot-scope="prop">
          <tr v-for="(item, index) in prop.rowData.details" :key="index">
            <td>{{ item.after_discount }}</td>
          </tr>
        </template>
        <template slot="organization-slot" slot-scope="prop">
          <tr :rowspan="prop.rowData.item_total">
            <td style="text-align: center; vertical-align: middle;">
              <span>{{ prop.rowData.details[0].organization }}</span>
            </td>
          </tr>
        </template>
        <template slot="user_type-slot" slot-scope="prop">
          <tr :rowspan="prop.rowData.item_total">
            <td style="text-align: center; vertical-align: middle;">
              <span>{{ prop.rowData.details.filter((e) => {return e.user_type !== null})[0].user_type }}</span>
            </td>
          </tr>
        </template>
        <template slot="remaining-slot" slot-scope="prop">
          <tr :rowspan="prop.rowData.item_total">
            <td style="text-align: center; vertical-align: middle;">
              <b>{{ prop.rowData.details.filter((e) => {return e.remaining !== null && e.type !== 'Normal' && e.type !== '-'})[0].remaining }}</b>
            </td>
          </tr>
        </template>
        <template
          slot="available_status-slot"
          slot-scope="prop"
        >
          <tr :rowspan="prop.rowData.item_total">
            <td style="text-align: center; vertical-align: middle;">
              <span class="ui green label" v-if="prop.rowData.details[0].available_status === true"><i class="fa fa-check"></i></span>
              <span class="ui red label" v-else><i class="fa fa-times"></i></span>
            </td>
          </tr>
        </template>
        <template slot="actions-slot" slot-scope="prop">
          <div class="custom-actions">
            <button v-if="$can('detail_promotion')" class="btn btn-info m-1" @click="onAction('detail-item', prop.rowData)" >Detail</button>
            <button v-if="$can('detail_promotion')" class="btn btn-success m-1" @click="onAction('edit-item', prop.rowData)" >Edit</button>
            <button v-if="$can('delete_promotion')" class="btn btn-danger m-1" @click="onAction('delete-item', prop.rowData)"><i class="fa fa-trash-o"></i></button>
          </div>
        </template>
      </vuetable>
    </div>
    <div class="vuetable-pagination ui basic segment grid">
      <vuetable-pagination-info ref="paginationInfo"
      ></vuetable-pagination-info>

      <vuetable-pagination ref="pagination"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>
  </div>
</template>
<script>
  import accounting from 'accounting'
  import Vue from 'vue'
  import Vuetable from 'vuetable-2/src/components/Vuetable'
  import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
  import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
  import moment from 'moment/src/moment'
  let FullDateNow = moment().format('YYYY-MM-DD hh:mm:ss')
  let startDate = '';
  let endDate = '';
  Vue.use(Vuetable)

  export default {
    components: {
      Vuetable,
      VuetablePagination,
      VuetablePaginationInfo,
    },
    prop: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    data() {
      return {
        startDate: '',
        endDate: '',
        isLoading: false,
        filterText: '',
        dateDetail: {
          start_from: '',
          end_from: ''
        },
        timeNow: FullDateNow,
        errors: {
          code: '',
          message: '',
          status: ''
        },
        apiUrl: process.env.VUE_APP_SECRET + process.env.VUE_APP_CONFIG + `promotion?type=multiple`,
        HttpOptions: {
          headers: {
            'Accept' : 'application/json',
            'Authorization' : 'Bearer ' + localStorage.getItem('access_token')
          }
        },
        sortOrder: [
          {
            field: 'created_at',
            sortField: 'created_at',
            direction: 'desc'
          }
        ],
        moreParams: {},
        fields: [
          {
            name: 'start_from-slot',
            sortField: 'start_from',
            title: 'Promotion Period'
          },
          {
            name: 'organization-slot',
            title: 'Organisasi/Partner'
          },
          {
            name: 'user_type-slot',
            sortField: 'user_type',
            title: 'Tipe User'
          },
          {
            name: 'name-slot',
            sortField: 'name',
            title: 'Nama Promosi'
          },
          {
            name: 'updated_at-slot',
            sortField: 'updated_at',
            title: 'Last Update'
          },
          {
            name: 'remaining-slot',
            title: 'Kuota',
            titleClass: 'center aligned',
            dataClass: 'center aligned'
          },
          {
            name: 'available_status-slot',
            titleClass: 'center aligned',
            dataClass: 'center aligned',
            title: 'Available',
          },
          {
            name: 'item_based-slot',
            title: 'Base Nominal',
            width: '10%',
          },
          {
            name: 'item-slot',
            title: 'Nilai Transaksi',
            width: '10%',
          },
          {
            name: 'type-slot',
            sortField: 'type',
            title: 'Tipe Promosi',
            width: '10%',
          },
          {
            name: 'after_discount-slot',
            titleClass: 'center aligned',
            dataClass: 'right aligned',
            title: 'Nilai Promosi',
            width: '10%',
          },
          {
            name: 'actions-slot',
            title: 'Actions',
            titleClass: 'center aligned',
            dataClass: 'center aligned'
          }
        ]
      }
    },
    methods: {
      doFilter () {
        this.$events.$emit('filter-set', this.filterText)
      },
      resetFilter () {
        this.filterText = ''  // clear the text in text input
        this.$events.$emit('filter-reset')
      },
      exportTable() {
        this.isLoading = true
        if (this.startDate != '' && this.endDate != '') {
          startDate = this.startDate;
          endDate = this.endDate;
        }else{
          endDate = this.$setDate.format('YYYY-MM-DD');
          startDate = this.$setDate.subtract(6, 'days').format('YYYY-MM-DD');
        }

        this.$http.get(`data-promotion/` + startDate + `/` + endDate)
        .then((result) => {
          this.isLoading = false
          const  exportPath = result.data.meta.data;
          window.location.href = exportPath;
        }).catch((error) => {
          if (error.response) {
            this.isLoading = false
            this.errors.code = error.response.status;
            this.errors.status = error.response.data.meta.code;
            this.errors.headers = error.response.headers;
          }
        })
      },
      handleLoadError(error) {
        this.errors.code = error.response.data.meta.code;
        this.errors.message = error.response.data.meta.message;
        this.errors.status = error.response.data.meta.code;
        if (this.errors.code == 401) {
          if (localStorage.getItem('access_token') != null) {
            localStorage.removeItem('access_token');
            this.$swal.fire(
              'Your session expired!',
              'Your session has expired. Please login again to access this page!',
              'error'
            ).then(() =>{
              this.$router.push("/login")
            })
          }
        }else if(this.errors.code == 403) {
          this.$router.push("/403")
        }else if(this.errors.code == 500) {
          this.$router.push("/500")
        }
      },
      activeLabel (value) {
        if (value == true) {
          return '<span class="ui green label"><i class="fa fa-check"></i></span>'
        }else{
          return '<span class="ui red label"><i class="fa fa-times"></i></span>'
        }
      },
      boughtLabel (value) {
        if (value == true) {
          return '<span class="ui green label"><i class="fa fa-check"></i></span>'
        }else{
          return '<span class="ui red label"><i class="fa fa-times"></i></span>'
        }
      },
      formatNumber (value) {
        return value > 100  ? "Rp." + accounting.formatNumber(value, 2) : value + " Gram"
      },
      onChangePage (page) {
        this.$refs.vuetable.changePage(page)
      },
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
        this.$refs.paginationInfo.setPaginationData(paginationData)
      },
      onAction (action, data) {
        if (action == 'detail-item') {
          this.$router.push({name: 'Detail Promotion', params: { id: data.details.filter((e) => {return e.user_type !== null})[0].id}})
        } else if (action == 'edit-item') {
          this.$router.push({name: 'Edit Promotion', params: { id: data.details.filter((e) => {return e.user_type !== null})[0].id}})
        }else{
          this.$swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this Promotion!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
          }).then((result) => {
            if (result.value) {
                this.$http.delete(`promotion/` + data.details.filter((e) => {return e.user_type !== null})[0].id)
                .then(() => {
                  this.$swal.fire(
                    'Deleted!',
                    'Promotion has been deleted.',
                    'success'
                  ).then(() => {
                    location.reload();
                  })
                }).catch((error) => {
                  if (error.response) {
                    this.errors.code = error.response.status;
                    this.errors.message = error.response.data.meta.message;
                    this.errors.status = error.response.data.meta.code;
                  }
                })
            } else if (result.dismiss === this.$swal.DismissReason.cancel) {
              this.$swal.fire(
                'Cancelled',
                'Promotion was successfully canceled for deletion!',
                'error'
              )
            }
          })
        }
      },
      onFilterSet (filterText) {
          this.moreParams = {
              'filter': filterText
          }
          Vue.nextTick( () => this.$refs.vuetable.refresh())
      },
      resetDateFilter () {
        this.startDate = ''
        this.endDate = ''
        this.$events.$emit('date-filter-reset')
      },
      doDateFilter(value){
        this.startDate = value.startDate;
        this.endDate = value.endDate;
        this.$events.fire('date-set', [this.startDate, this.endDate])
      },
      onDateSet()  {
        this.start_from = this.startDate;
        this.end_to = this.endDate;
        this.moreParams = {
          'start_from': this.start_from,
          'end_to': this.end_to
        }
        Vue.nextTick( () => this.$refs.vuetable.refresh())
      },
      onFilterReset () {
          this.moreParams = {}
          Vue.nextTick( () => this.$refs.vuetable.refresh())
      },
      onDateFilterReset () {
        this.moreParams = {}
        Vue.nextTick( () => this.$refs.vuetable.refresh())
      }
    },
    mounted() {
      this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
      this.$events.$on('date-set', eventData => this.onDateSet(eventData))
      this.$events.$on('filter-reset', () => this.onFilterReset())
      this.$events.$on('date-filter-reset', () => this.onDateFilterReset())
    },
  }
</script>
<style>

.badge--code {
  font-size: 10pt !important;
}
/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
}

</style>
<style lang="scss" scoped>
  .ui.table {
    display: block !important;
    overflow-x: auto !important;
  }
</style>
<style src="spinkit/scss/spinkit.scss" lang="scss" />

